import { RestApiService } from '@frontend/unhideschool/app/api-gateway/services/rest-api.service';
import { Component, Output, EventEmitter, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { LoggedUserStateService } from '@frontend/unhideschool/core/services/legacy/logged-user.state';
import { environment } from '@frontend/unhideschool/env';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'unh-comment-box-reply',
  templateUrl: './comment-box-reply.component.html',
  styleUrls: ['./comment-box-reply.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentBoxReplyComponent implements OnInit {
  @Output() replySubmitted = new EventEmitter<any>();
  @Output() closeReplyInput = new EventEmitter();

  defaultAvatarUrl = environment.defaultAvatarUrl;

  replyText = null;
  submitDisabled = true;
  userAvatarUrl = '';

  commentImages: any;

  constructor(
    public luss: LoggedUserStateService,
    private rest: RestApiService
  ) { }

  ngOnInit(): void {
    this.userAvatarUrl = this.luss.getProfilePicture();
  }

  onReplyEditorChanged(e) {
    this.replyText = e.html;

    if ((e.text.match(/[^\s]/) || this.commentImages.length > 0)) {
      this.submitDisabled = false;
    } else {
      this.submitDisabled = true;
    }
  }

  submitReply() {
    const uploadedImages = [];
    let count = 0;

    if (this.commentImages.length > 0) {
      this.commentImages.forEach(image => {
        const data = new FormData();
        data.append('file', image.file, image.file.name);
        data.append('mediacontenttype', 'communitymediaitem');

        this.rest.upload('/media/uploadfile', data).pipe(
          filter(res => res.status === 'complete')
        ).subscribe(res => {
          if (res.success) {
            count++;

            const uploadedImage = {
              id: res.message.dict.fileid,
              url: res.message.dict.urlimage
            };

            uploadedImages.push(uploadedImage);
            this.replyText = this.replyText.replace(image.blobUrl, uploadedImage.url);

            if (count == this.commentImages.length) {
              this.replySubmitted.emit({ text: this.replyText, newimages: uploadedImages });
              this.replyText = null;
            }
          }
        })
      })
    } else {
      this.replySubmitted.emit({ text: this.replyText });
      this.replyText = null;
    }
  }

  onImagesChanged(images) {
    this.commentImages = images;

    if (this.commentImages && this.commentImages.length > 0) {
      this.submitDisabled = false;
    }
  }

  closeReply() {
    this.closeReplyInput.emit(true);
  }
}
